import React from 'react';

const TRENDS = {
  improving: { symbol: '\u25B2', color: '#00b894', label: 'Improving' },
  stable: { symbol: '\u25AC', color: '#636e72', label: 'Stable' },
  degrading: { symbol: '\u25BC', color: '#d63031', label: 'Degrading' },
  declining: { symbol: '\u25BC', color: '#d63031', label: 'Declining' },
};

export default function TrendBadge({ trend, pct }) {
  const t = TRENDS[trend] || TRENDS.stable;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      fontSize: 12,
      fontWeight: 600,
      color: t.color,
    }}>
      {t.symbol} {t.label}
      {pct !== undefined && <span style={{ fontWeight: 400, opacity: 0.7 }}>({pct > 0 ? '+' : ''}{Math.round(pct)}%)</span>}
    </span>
  );
}
